import { ChipComponent } from './chip.component';

export class ChipCloseEvent {
    constructor(public source: ChipComponent) {}
}
